
const error = (filename, msg) => {
    let error = new Error(msg);
    error.filename = filename;
    return error;
}

class FileUploadService {

    sendFile = (file, options) =>{
        return new Promise((resolve, reject) => {
            console.log('FileUploadService', file);
            const formData = new FormData();
            for (let field in options.params){
                formData.append(field, options.params[field])
            }
            formData.append(options.name, file);
            var xhr = new XMLHttpRequest();
            xhr.upload.addEventListener("progress", function (evt) {
                console.log("progress...");
                if (evt.lengthComputable) {
                    var percent = Math.round(evt.loaded * 100 / evt.total);
                    options.onProgress(file.name, percent);
                }

            }, false);
            xhr.addEventListener("load", function (evt){
                console.log("load...");
                if ( xhr.status !== 200 ){
                    reject(error(file.name, `${xhr.status}: ${xhr.statusText}`));
                }
                else{
                    const jsonResp = JSON.parse(xhr.response);
                    if ( jsonResp.rspCode === 'ok'){
                        resolve(jsonResp.files[0]);
                    }
                    else{
                        reject(error(file.name, `rsp is not ok. something went wrong in app`));
                    }

                }
            }, false);
            xhr.addEventListener("error", function (evt){
                console.log("error...");
                reject(error(file.name, `${xhr.status}: ${xhr.statusText}`));
            }, false);
            xhr.addEventListener("abort", function (evt){
                console.log("abort...");
                reject(error(file.name, `${xhr.status}: ${xhr.statusText}`));
            }, false);
            xhr.open("POST", options.url);
            xhr.send(formData);
        });
    }
}

const fileUploadService = new FileUploadService();

export default fileUploadService;